import Image from "next/image";
import CardPaper from "@components/UI/CardPaper";
import s from "./styles.module.sass";
import starIcon from "../../../../../../public/icons/star.svg";
import Avatar from "@components/UI/Avatar";
import { ROUTES } from "../../../../../constants/ROUTES";
import { getInitials } from "@shared/functions/getInitials";
import { pluralForm } from "@shared/functions/pluralForm";
import { AuthorProps } from "@features/Course/parts/course/Author/typedef";
import checkAndPrepareRating from "@shared/functions/checkAndPrepareRating";

const Author = ({ author }: AuthorProps) => {
	const {
		firstName,
		lastName,
		bio,
		id,
		rating,
		photo,
		competence,
		amountStudents,
		amountReviews,
		amountCourses,
	} = author;
	const fullName = `${firstName} ${lastName}`;

	const preparedRating = checkAndPrepareRating(rating);

	return (
		<section className={s.courseAuthor}>
			<h2 className={s.title}>Автор курса</h2>
			<CardPaper className={s.cardLinkWrapper}>
				<div className={s.authorMainInfoWrapper}>
					<div className={s.authorPhotoWrapper}>
						<Avatar
							link={`${ROUTES.INSTRUCTOR}/${id}`}
							size="xlarge"
							photo={photo}
							initials={getInitials(firstName, lastName)}
						/>
					</div>

					<div className={s.authorInfoWrapper}>
						<h3 className={s.authorFullName}>{fullName}</h3>
						<p className={s.authorDescription}>{competence}</p>
					</div>

					<div className={s.ratingAndAuthorAdditionalInfoWrapper}>
						<div className={s.ratingWrapper}>
							<Image src={starIcon} width={18} height={18} alt="Star" />
							<b>{preparedRating}</b>
						</div>

						<div>
							<b>{amountReviews}</b>&nbsp;
							{pluralForm(amountReviews, "отзыв", "отзыва", "отзывов")}
						</div>

						<div>
							<b>{amountStudents}</b>&nbsp;
							{pluralForm(amountStudents, "студент", "студента", "студентов")}
						</div>

						<div>
							<b>{amountCourses}</b>&nbsp;
							{pluralForm(amountCourses, "курс", "курса", "курсов")}
						</div>
					</div>
				</div>
				{bio && <div className={s.authorBio}>{bio}</div>}
			</CardPaper>
		</section>
	);
};

export default Author;
